import Gravity from 'gravityglobal-parent/assets/js/global-functions';
import { addInViewportAttribute } from '@gravity-global/helpers/add-in-viewport-attribute';

import { searchResult } from './helpers/search-result';
import initHeader from './header';
import initScrollToTopButton from './back-to-top-button';
import initCookieBar from './cookie-bar';
import accordionCompetitive from './accordion-competitive';
import initTableOfContent from './tablet-of-content';
import initBackToLinkButton from './back-to-link-button';
import print from './print';

// In this function you add all the code that needs to run after the document is ready
Gravity.ready(() => {
  searchResult();
  setTimeout(initHeader, 0);
  initScrollToTopButton();
  initCookieBar();
  initTableOfContent();
  accordionCompetitive();
  initBackToLinkButton();
  print();
});

// Code that doesn't need "document ready" goes here
Gravity.handleFirstTab();

// Global modules animation
const animatedSections = document.querySelectorAll('[data-animated-section="true"]');

addInViewportAttribute([...animatedSections], 'data-in-view', 'true', false, { rootMargin: '-70px' });

const browserDetection = () => {
  let isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
  let isWindows = navigator.platform.indexOf('Win') > -1;
  let isMac = navigator.platform.indexOf('Mac') > -1;
  let isIPhone = /iPhone/i.test(navigator.userAgent);
  let isIPad = /iPad/i.test(navigator.userAgent) && /CriOS/i.test(navigator.userAgent);

  if (isFirefox) {
    document.documentElement.classList.add('firefox');
  }
  if (isWindows) {
    document.documentElement.classList.add('windows');
  }
  if (isMac) {
    document.documentElement.classList.add('mac');
  }
  if (isIPhone) {
    document.documentElement.classList.add('iphone');
  }
  if (isIPad) {
    document.documentElement.classList.add('ipad-chrome-ios');
  }
};

browserDetection();
